import axiosClient, { unwrap } from "./axiosClient";
import { ENDPOINTS } from "./endpoints";

export const companyApi = {
  getAll: () => axiosClient.get(ENDPOINTS.bottleCompanies.list).then(unwrap),
  create: (data) =>
    axiosClient.post(ENDPOINTS.bottleCompanies.create, typeof data === "string" ? { companyName: data } : data).then(unwrap),
  update: (id, data) =>
    axiosClient.put(ENDPOINTS.bottleCompanies.update(id), typeof data === "string" ? { companyName: data } : data).then(unwrap),
  setStatus: (id, status) =>
    axiosClient.patch(ENDPOINTS.bottleCompanies.status(id), null, { params: { status } }).then(unwrap),
};
